var headers;
window.addEventListener('DOMContentLoaded', function () {
  headers = document.querySelectorAll('.acc-header button');

  // Toggle the visibility of each panel when their respective header buttons are activated
  headers.forEach(function (header) {
    header.addEventListener('click', function () {
      // Flip aria-expanded to indicate the new state of the panel
      var isExpanded = header.getAttribute('aria-expanded') === 'true';
      header.setAttribute('aria-expanded', !isExpanded);

      // Animate the panel transition between expanded/collapse
      var panel = document.getElementById(header.getAttribute('aria-controls'));
      slideToggle(panel);
    });
  });
});

function slideToggle(element) {
  var style = window.getComputedStyle(element);
  if (style.display === 'none') {
    element.style.display = 'block';
  } else {
    element.style.display = 'none';
  }
}